import { DialogSize } from '@thyme/nashville/src/types/dialogs'
import { AllowedIcons } from '@thyme/nashville/src/types/icons'
import { ColorPalettes } from '@thyme/nashville/src/types/shared'
import { createProp } from '@thyme/nashville/src/utils/designTokens'
import type { ExtractPropTypes } from 'vue'

export const T_DIALOG_PROPS = {
  visible: {
    type: Boolean,
    default: false,
  },
  draggable: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: '',
  },
  warning: {
    type: Boolean,
    default: false,
  },
  size: createProp(DialogSize, DialogSize.SM),
  titleIcon: createProp(AllowedIcons),
  titleIconColor: createProp(ColorPalettes),
  blocking: {
    type: Boolean,
    default: true,
  },
  closable: {
    type: Boolean,
    default: true,
  },
} as const

export type TDialogProps = ExtractPropTypes<typeof T_DIALOG_PROPS>
